export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8425.db4e21fc.jpg";